module.exports = __webpack_public_path__ + "img/green-save.55cb5524.svg";